import errorManager from '@/rollbar.js';

const fillDeleteModalChose = function () {
  $('#modal-delete-confirm').modal('show');
  const target_url = $(this).data('gad-target-url');
  $('#delete_gad').attr('href', target_url);
  $('#delete_gads').attr('href', target_url + '?all=true');
};

const setListener = () => {
  $(document).on('click', 'span.delete_modal_caller', fillDeleteModalChose);
  $('#form-guest-activities-search--from').datepicker('option', 'onSelect', function () {
    $(this).closest('form').submit();
  });
};

const init = () => {
  try {
    setListener();
  } catch (e) {
    errorManager(e);
  }
};

window.Domestics = {
  init: init,
};
